export default __webpack_public_path__ + "21a21d0b26b275c96f5abb6dbf5ffe78.gif";